import {action, observable, runInAction} from 'mobx'
import {decorate, inject, injectable} from '@yosmanyga/di'
import {PhoneType} from '@yosmanyga/phone'
import {CredentialManager} from "@yosmanyga/base";
import {
  AuthenticationFrontendWithPhoneAbstractApi,
  AuthenticationFrontendWithPhoneExpiredCodeApiException
} from '../../data'

class AuthenticationFrontendWithPhoneCompleteController {
    @observable accessor phone: PhoneType | undefined
    @observable accessor code!: string
    @observable accessor error!: string
    @observable accessor loading: boolean
    @observable accessor completing: boolean
    @observable accessor completed: boolean

    constructor(
        private authenticationFrontendApi: AuthenticationFrontendWithPhoneAbstractApi,
        private credentialsManager: CredentialManager,
    ) {
        this.loading = true
        this.completing = false
        this.completed = false
    }

    @action load = (
        phone?: PhoneType
    ) => {
        this.phone = phone
        this.loading = false
    }

    prepare = (
        code: string
    ) => {
        runInAction(() => {
            this.error = ''
            this.code = code
        })
    }

    complete = async () => {
        runInAction(() => {
            this.error = ''
            this.completing = true
        })

        if (!this.code) {
            runInAction(() => {
                this.error = 'Escribe el código de verificación'
                this.completing = false
            })

            return
        }

        if (!this.phone) {
            throw new Error();
        }

        let user, token

        try {
            const data = await this.authenticationFrontendApi.complete(
                this.phone,
                this.code
            );

            user = data.user
            token = data.token
        } catch (e) {
            runInAction(() => {
                this.error = e instanceof AuthenticationFrontendWithPhoneExpiredCodeApiException
                    ? 'El código de verificación ha expirado. Te hemos enviado un nuevo código de verificación'
                    : 'El código de verificación es incorrecto'
                this.completing = false
            })

            return
        }

        await this.credentialsManager.save({
            user: user,
            token: token
        })

        runInAction(() => {
            this.completing = false
            this.completed = true
        })
    }
}

decorate(injectable(), AuthenticationFrontendWithPhoneCompleteController)
decorate(inject(AuthenticationFrontendWithPhoneAbstractApi), AuthenticationFrontendWithPhoneCompleteController, 0)
decorate(inject(CredentialManager), AuthenticationFrontendWithPhoneCompleteController, 1)

export {
    AuthenticationFrontendWithPhoneCompleteController
}
